export const blockIconsMapsCategory = (
	<span className='material-symbols-outlined'>category</span>
);
